// frontend/src/components/common/BotonesPieFormulario.jsx
// Fila de Cancelar + Guardar compartida por los formularios de pantalla
// completa de la app móvil (parte diario, combustible, lubricantes), para
// que el pie se vea igual —mismo tamaño de botón, mismos colores, mismo
// radio de borde— sin importar cuál de los tres se esté cargando.
import styled from 'styled-components';

export const FilaBotonesPie = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  gap: 10px;
  align-items: stretch;
`;

export const BotonCancelarPie = styled.button`
  flex: 0 0 auto;
  min-width: 96px;
  min-height: 52px;
  padding: 0 20px;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: transparent;
  color: ${({ theme }) => theme.colors.txtPrincipal};
  font-size: 1rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover:not(:disabled) { background: ${({ theme }) => theme.colors.surfaceHover}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const BotonGuardarPie = styled.button`
  flex: 1;
  min-width: 0;
  width: 100%;
  min-height: 52px;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  font-size: 1rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover:not(:disabled) { background: ${({ theme }) => theme.colors.primaryHover}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;
